import Vue from 'vue'
import Vuex from 'vuex'



Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    'finishedLoadingData': false
  },
  mutations: {
    init (state, item) {
      for (let key of item) {
        state[key] = item[key]
      }
    },
    finishedLoadingData (state) {
      state['finishedLoadingData'] = true
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/assets/js/store.js